import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=484571dd&lang=pug&"
import script from "./Icon.vue?vue&type=script&lang=js&"
export * from "./Icon.vue?vue&type=script&lang=js&"
import style0 from "./Icon.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('484571dd')) {
      api.createRecord('484571dd', component.options)
    } else {
      api.reload('484571dd', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=484571dd&lang=pug&", function () {
      api.rerender('484571dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Icon.vue"
export default component.exports